import type { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { ColorNeutralDarkGrey } from 'autogen/design-tokens/tokens';
import type { PriceLabelType } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon';
import type { PriceModuleProps, Size } from '../shared/types';
import usePriceLabelInfo from './hooks/usePriceLabelInfo';

const LabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.Spacing8};
`;

const LabelText = styled(Typography.Body)<{ $type: PriceLabelType }>`
    ${({ $type }) =>
        ($type === 'ClubMatasOnlyPrice' || $type === 'MultiBuyPrice') &&
        css`
            color: ${({ theme }) => theme.ColorTextSale};
        `}
    ${({ $type }) =>
        $type === 'FixedLowPrice' &&
        css`
            color: ${({ theme }) => theme.ComponentsLabelFixedPriceTextInverted};
        `}
`;

const InfoButton = styled.button`
    display: flex;
    padding: ${({ theme }) => `${theme.Spacing2} ${theme.Spacing4}`};
    margin: 0;
    background: 0;
    border: 0;
`;

type PriceLabelProps = {
    priceLabel: NonNullable<PriceModuleProps['priceLabel']>;
    size: Size;
} & HTMLAttributes<HTMLDivElement>;

export default function PriceLabel(props: PriceLabelProps) {
    const {
        priceLabel: { isInfoIconEnabled, text, type },
        size,
        className
    } = props;
    const openInfo = usePriceLabelInfo();

    if (isInfoIconEnabled && size === 'lg') {
        return (
            <LabelContainer className={className}>
                <LabelText $type={type} size={'M'} strong forwardedAs="span">
                    {text}
                </LabelText>
                {isInfoIconEnabled && (
                    <InfoButton type="button" onClick={() => openInfo(type)}>
                        <Icon type="Information" size={16} fill={ColorNeutralDarkGrey} />
                    </InfoButton>
                )}
            </LabelContainer>
        );
    }

    return (
        <LabelText $type={type} size={size === 'lg' ? 'M' : 'S'} strong className={className} forwardedAs="span">
            {text}
        </LabelText>
    );
}
